module.exports = __webpack_public_path__ + "media/components/assets/sujung_04-2d6bc6c9876d924bfcf36c172223cc08.png";